export default "__VITE_ASSET__772e7632__"